import { createSelector } from 'reselect';
import { AppState } from '../types';
import { HelpState } from './slice';

export const helpStateSelector = (state: AppState): HelpState => state.help;

export const referenceSelector = createSelector(helpStateSelector, (s: HelpState) => s.reference);
